// @ts-nocheck

import { connect } from 'react-redux'
import { Route, Routes } from 'react-router-dom-v5-compat'
import { CONFIG } from 'shared/constants'
import { roadAheadResponse } from 'registry/constants'
import RoadAhead from '../../onboarding/components/slides/RoadAhead/road-ahead'
import Pregnancy from '../../onboarding/components/slides/pregnancy'
import Adoption from '../../onboarding/components/slides/adoption'
import StillTrying from '../../onboarding/components/slides/StillTryingAffirmation/still-trying-affirmation'
import {
  setIsArrivalDateKnown,
  setPlanningStage,
  setUserResponse,
} from '../actions'
import withRouter from 'shared/HOC/withRouter'

export const ROADS = {
  ADOPTION: {
    planningStage: CONFIG.registry.planningStageOptions.adopting,
    relativePath: 'adoption',
    path: '/road-ahead/adoption',
    onboardingResponse: roadAheadResponse.ADOPTION,
  },
  STILL_TRYING: {
    planningStage: CONFIG.registry.planningStageOptions.conceiving,
    relativePath: 'still-trying',
    path: '/road-ahead/still-trying',
    onboardingResponse: roadAheadResponse.STILL_TRYING,
  },
  PREGNANCY: {
    planningStage: CONFIG.registry.planningStageOptions.pregnant,
    relativePath: 'pregnancy',
    path: '/road-ahead/pregnancy',
    onboardingResponse: roadAheadResponse.PREGNANCY,
  },
  SURROGACY: {
    planningStage: CONFIG.registry.planningStageOptions.surrogate,
    relativePath: 'surrogacy',
    path: '/road-ahead/surrogacy',
    onboardingResponse: roadAheadResponse.SURROGACY,
  },
}

function PathToParenthood({ nextPath, onSelectRoadAhead }) {
  return (
    <Routes>
      <Route
        index
        element={
          <RoadAhead options={ROADS} onSelectRoadAhead={onSelectRoadAhead} />
        }
      />
      <Route
        path={`${ROADS.PREGNANCY.relativePath}/*`}
        element={<Pregnancy nextPath={nextPath} />}
      />
      <Route
        path={`${ROADS.SURROGACY.relativePath}/*`}
        element={<Pregnancy nextPath={nextPath} />}
      />
      <Route
        path={`${ROADS.ADOPTION.relativePath}/*`}
        element={<Adoption nextPath={nextPath} />}
      />
      <Route
        path={`${ROADS.STILL_TRYING.relativePath}/*`}
        element={<StillTrying nextPath={nextPath} />}
      />
    </Routes>
  )
}

export const mapDispatchToProps = (dispatch, { router }) => ({
  onSelectRoadAhead: (roadAhead) => {
    dispatch(setUserResponse({ roadAhead: roadAhead.onboardingResponse }))

    dispatch(setPlanningStage(roadAhead.planningStage))
    if (roadAhead === ROADS.ADOPTION) {
      dispatch(setIsArrivalDateKnown(false))
    }
    router.navigate(roadAhead.path)
  },
})

export default withRouter(connect(null, mapDispatchToProps)(PathToParenthood))
